import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=f0f4c9be"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0f4c9be')) {
      api.createRecord('f0f4c9be', component.options)
    } else {
      api.reload('f0f4c9be', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=f0f4c9be", function () {
      api.rerender('f0f4c9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/PrivacyPolicy.vue"
export default component.exports